import React from 'react';
import { useStyles } from 'components/Statistics/styles';

import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

import _ from 'lodash';
import { CHART_COLORS, CHART_HEIGHT, CHART_WIDTH } from './Statistics';
import StatisticsDownloadButton from 'components/Button/StatisticsDownloadButton';
import { ExportTaskType } from 'commons/vo/param/StatisticsExportParamVO';
import { formatNumberWithComma, formatTooltipLabel } from './utils';

type LoginProps = {
  statisticsLoginData: LineChartData[];
  startDate: string;
  endDate: string;
};

function Login({ statisticsLoginData, startDate, endDate }: LoginProps) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.sectionTitleBox}>
        <div className={classes.sectionTitle}>사용자 접속</div>
        <StatisticsDownloadButton
          taskType={ExportTaskType.Login}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      <div className={classes.sectionBody}>
        <LineChart
          width={CHART_WIDTH}
          height={CHART_HEIGHT}
          data={statisticsLoginData}
          margin={{ top: 30, bottom: 5, left: 25, right: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: '횟수', position: 'top', offset: 15 }} width={20} />
          <Tooltip
            labelFormatter={value => {
              return [formatTooltipLabel(value)];
            }}
            formatter={value => {
              return [`${formatNumberWithComma(value)}회`, '총 사용자 접속'];
            }}
          />
          <Line dataKey="value" stroke={CHART_COLORS.default} isAnimationActive={false} />
        </LineChart>
      </div>
    </div>
  );
}

export default Login;
